import styled from 'styled-components';

import { Breadcrumb } from '@poliedro/tamentai';

export const CustomBreadcrumbItem = styled(Breadcrumb.Item)`
  svg {
    display: inline !important;
  }

  @media (max-width: 999px) {
    &:first-child svg {
      display: inline !important;
    }
  }
`;
